import React from 'react';

const PencilIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M13.3398 7.38136L5.24028 15.4788L0.620605 15.8792L1.02095 11.2595L9.11861 3.16062L9.11842 3.15999L10.2498 2.02862H10.2506L12.1188 0.161621L16.3392 4.38205L13.3398 7.38136ZM10.2506 4.29162L2.5648 11.977L2.3788 14.12L4.5218 13.934L12.2076 6.24862L10.2506 4.29162ZM12.1188 2.42399L11.3816 3.16062L13.3386 5.11762L14.0758 4.38099L12.1188 2.42399Z" 
                fill="currentColor"
            />
        </svg>
    );
};

export default PencilIcon;
